import * as config from './config'
export default {
  stringEmpty: function (value) {
    var empty = false
    if (value === null || value === undefined || value === '' || value === 'null') {
      empty = true
    }
    return empty
  },
  validateEmail: function (value) {
    var myreg = new RegExp(/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/)
    if (!myreg.test(value)) {
      return false
    } else {
      return true
    }
  },
  isTel: function (value) {
    // var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/
    var isMob = /^((\+?86)|(\(\+86\)))?1[3-9](\d{9})$/
    if (isMob.test(value)) {
      return true
    } else {
      return false
    }
  },
  isStarryNo: function (account) {
    var isStarry = /^(\d{6,7})$/
    if (isStarry.test(account)) {
      return true
    } else {
      return false
    }
  },
  passwordRule: function (password) {
    var validate = true
    if (this.stringEmpty(password)) {
      validate = false
    } else {
      if (password.length < 8 || password.length > 20) {
        validate = false
      }
    }
    return validate
  },
  lang: function () {
    var requestLang = config.getReqParam('lang')
    var currentLang = config.cookieGet('lang')
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang
      config.cookieSet('lang', currentLang)
    }
    if (!currentLang) {
      // 判断除IE外其他浏览器使用语言
      currentLang = navigator.language
      // 判断IE浏览器使用语言
      if (!currentLang) {
        currentLang = navigator.browserLanguage
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en'
    }
    return currentLang
  },
  passwordOK: function (pwd) {
    const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
    return reg.test(pwd)
  }
}



// WEBPACK FOOTER //
// ./src/common/script/validate.js